module.exports = __webpack_public_path__ + "static/media/logo-visa.1c6ccb4f.svg";